// Parcel Map

<template>
  <div id="map">
    <component
      :is="'script'"
      src="hkttps://maps.googleapis.com/maps/api/js?key=AIzaSyALwCqudTG-Do1ee8WvteZJ0NBirCWOQ84&callback=initMap&libraries=&v=weely"
      async
    />

    <div id="map" ref="map"></div>
  </div>
</template>

<script>
import { get } from "../../js/http";

import PageBase from "../PageBase.vue";

export default {
  extends: PageBase,
  name: "lms5020",

  data() {
    return {
      map: null,
      regionId: 0,
      lot: "",
      parcel: [],
      blockNumber: "",
      lotNumber: "",
      area: "",
      surveyPlan: "",
    };
  },

  methods: {
    getTargetPath() {
      const me = this,
        q = {};

      if (me.regionId) {
        q.regionId = me.regionId;
      }

      if (me.parcelId) {
        q.parcelId = me.parcelId;
      }

      if (me.surveyId) {
        q.surveyId = me.surveyId;
      }

      return {
        name: me.$options.name,
        query: q,
      };
    },

    syncValues(p, q) {
      const me = this;

      if ("regionId" in q) {
        me.regionId = parseInt(q.regionId);
      } else {
        if ("regionId" in p) {
          me.regionId = parseInt(p.regionId);
        } else {
          me.regionId = 0;
        }
      }

      if ("surveyId" in q) {
        me.surveyId = parseInt(q.surveyId);
      } else {
        if ("surveyId" in p) {
          me.surveyId = parseInt(p.surveyId);
        } else {
          me.surveyId = 0;
        }
      }

      if ("parcelId" in q) {
        me.parcelId = parseInt(q.parcelId);
      } else {
        if ("parcelId" in p) {
          me.parcelId = parseInt(p.parcelId);
        } else {
          me.parcelId = 0;
        }
      }
    },

    // getMapInfo () {
    //   return get('api/rgn/' + this.regionId+ '/map');
    // },
    getMapInfo() {
      return get("api/rgn/" + this.regionId + "/map/parcels/" + this.parcelId);
    },

    getParcel() {
      return get("api/rgn/" + this.regionId + "/parcels/" + this.parcelId);
    },

    loadData() {
      const me = this;

      me.getParcel().then(
        (info) => {
          if (info) {
            me.parcel = info.parcel[0];
            me.blockNumber = me.parcel.blockNumber;
            me.lotNumber = me.parcel.lotNumber;
            me.area = me.parcel.area;
            me.surveyPlan = me.parcel.surveyPlan;
          }
        },
        (fault) => {
          me.showFault(fault);
        }
      );

      me.getMapInfo().then(
        (lots) => {
          me.lot = lots;

          me.showMap();
        },
        (fault) => {
          me.showFault(fault);
        }
      );
    },

    initMap() {
      const me = this;

      me.loadData();
    },

    showMap() {
      const me = this;

      let element = me.$refs["map"];
      let options = {
        zoom: 20,
        mapTypeId: window.google.maps.MapTypeId.Terrain,
        center: { lat: 14.142486286111, lng: 121.270054311111 }, //Philippines
        // name:'Test',
        // label:'',
        // title:'Test',
      };

      me.map = new window.google.maps.Map(element, options);

      if (me.map) {
        me.map.data.addGeoJson(JSON.parse(this.lot));
      }

      me.map.data.setStyle(function(feature) {
        var parcelIdMap = feature.getProperty("parcelId");
        var surveyIdMap = feature.getProperty("surveyId");
        var adjoiningLotNumber = feature.getProperty("lotNumber");
        var color = rgbToHex(generateRandomColor(color));
        var strokeWeight = 0.1; //ascii < 91 ? .5 : .1;
        // var lat = feature.getProperty("latitude");
        // var lon = feature.getProperty("longitude");
        // var point = feature.getProperty('coordinates');
        var parcelId = me.parcelId; //1365526; //Eugene dito ka magpasa ng parcelId
        var surveyId = me.surveyId; //Eugene dito ka magpasa ng parcelId
        var fillOpacity = 0.1;

        if (surveyIdMap == surveyId) {
          strokeWeight = 1;
          if (parcelIdMap == parcelId) {
            color = "red";
            fillOpacity = 1;
          }

          let bounds = new window.google.maps.LatLngBounds();
          let geometry = feature.getGeometry();

          geometry.getArray().forEach((path) => {
            path.getArray().forEach((latLng) => {
              bounds.extend(latLng);
            });
          });

          let center = bounds.getCenter();

          var text = adjoiningLotNumber; // Dito ka magpasa ng Lot and Block Number

          if (parcelIdMap == parcelId) {
            me.map.setCenter(
              new window.google.maps.LatLng(center.lat(), center.lng())
            );
            // text =
            //   "Lot " + me.lotNumber + " A= " + me.area + " S= " + me.surveyPlan;
            // color = "red";

            // text =  me.lotNumber  + ' Area ' + me.area + ' Survey ' + me.surveyPlan // Dito ka magpasa ng Lot and Block Number
          }

          // var hc = { lat: center.lat(), lng: center.lng() };

          // var marker = new window.google.maps.Marker({
          //   position: hc,
          //   map: me.map,
          //   icon: "../res/img/empty.png",
          //   label: {
          //     fontWeight: "bold",
          //     text: text, //"Lot Number 2120 " + " Area 4996" + " Survey 12", // Dito ka magpasa ng Lot and Block Number
          //     fontSize: "15px",
          //   },
          // });
        }

        return {
          fillColor: color,
          strokeWeight: strokeWeight,
          fillOpacity: fillOpacity,
          icon: "http://maps.google.com/mapfiles/kml/pal3/icon0.png",
        };
      });

      // function positionMarker(lat, lang) {
      //   var test = new window.google.maps.Marker({
      //     position: { lat: lat, lng: lang },
      //     map,
      //     title: "XXXX",
      //   });
      // }

      function generateRandomColor() {
        var color = [];
        for (var i = 0; i < 3; i++) {
          color.push(Math.floor(Math.random() * 250));
        }
        return color;
      }

      me.map.data.addListener("mouseover", (event) => {
        me.map.data.revertStyle();
        me.map.data.overrideStyle(event.feature, { strokeWeight: 1 });
      });
      // me.map.data.addListener("mouseout", (event) => {
      //   me.map.data.revertStyle();
      // });

      // function positionMarker(lat, lang) {
      //   var test = new window.google.maps.Marker({
      //     position: { lat: lat, lng: lang },
      //     icon: "http://maps.google.com/mapfiles/kml/pal3/icon0.png",
      //     map,
      //     title: "XXXX",
      //   });
      // }

      function rgbToHex(color) {
        var hex = [];
        for (var i = 0; i < 3; i++) {
          hex.push(color[i].toString(16));
          if (hex[i].length < 2) {
            hex[i] = "0" + hex[i];
          }
        }
        return "#" + hex[0] + hex[1] + hex[2];
      }

      me.map.data.addListener("click", function(event) {
        event.feature.setProperty("isColorful", true);
      });
    },
  },

  mounted() {
    const me = this;

    me.syncValues(me.params, me.query);

    // console.log(me.surveyId);
    // console.log(me.parcelId);
    // console.log(me.regionId);

    window.initMap = me.initMap;
  },
};
</script>

<style scoped>
#map {
  /* height: 600px; */
  height: calc(100vh - 74px);
  background: gray;
}
</style>
